module.exports = require("./kab.js");